import { toast } from 'sonner';

export function planLimitMessage(detail) {
  if (typeof detail === 'string') return detail;
  if (detail && typeof detail === 'object') {
    return String(detail.message || detail.detail || '');
  }
  return '';
}

/** Show billing upgrade toast for plan-limit 403 responses. Returns true when handled. */
export function toastPlanLimitError(detail, status = 403) {
  if (status !== 403) return false;
  const msg = planLimitMessage(detail);
  if (!msg.toLowerCase().includes('plan limit reached')) return false;
  toast.error('Plan limit reached', {
    description: `${msg} Open Billing to upgrade.`,
    action: {
      label: 'Billing',
      onClick: () => {
        window.location.assign('/admin/billing');
      },
    },
  });
  return true;
}
